<template>
  <div class="flex flex-col min-h-screen relative">
    <header
      class="flex border-b-corepla-light border-b-8 shadow h-[75px] items-center text-corepla-text"
      :data-version="version"
    >
      <div
        v-if="authStore.isAuthenticated"
        class="md:hidden"
      >
        <Bars3Icon
          class="w-8 h-8 inline-block cursor-pointer"
          @click="toggleMenu"
        />
      </div>

      <div>
        <div class="py-2 px-2">
          <RouterLink
            to="/"
            class="flex items-center"
          >
            <img
              class="w-[70px]"
              src="https://assets.astecorepla.com/logo-corepla.png"
            >
            <div class="ml-4 font-bold">
              Aste Corepla
            </div>
          </RouterLink>
        </div>
      </div>
      <div class="flex-grow" />
      <div
        v-if="authStore.isAuthenticated"
        class="py-2 px-2"
      >
        <nav
          class="text-right flex items-center cursor-pointer"
          @click="userDropdown = true"
        >
          <div class="mr-2 text-xs">
            <div class="font-bold">
              {{ authStore.user.nickname }}
            </div>
            <div class="">
              {{ dateUtils.formatWithSeconds(clockStore.clock) }}
            </div>
          </div>
          <img
            :src="authStore.user.picture"
            class="h-[50px]"
          >
        </nav>
        <div
          v-if="userDropdown"
          v-on-click-outside="closeUserDropdown"
          class="absolute right-0 bg-white w-[200px] shadow text-black text-sm z-10"
        >
          <div class="flex justify-around my-2">
            <div
              class="hover:bg-corepla-bg-light p-2 cursor-pointer"
              @click="$i18n.locale = 'it'"
            >
              <svg
                viewBox="0 0 640 480"
                class="h-6 w-6 inline-block"
              >
                <g
                  fill-rule="evenodd"
                  stroke-width="1pt"
                >
                  <path
                    fill="#fff"
                    d="M0 0h640v480H0z"
                  />
                  <path
                    fill="#009246"
                    d="M0 0h213.3v480H0z"
                  />
                  <path
                    fill="#ce2b37"
                    d="M426.7 0H640v480H426.7z"
                  />
                </g>
              </svg>
            </div>
            <div
              class="hover:bg-corepla-bg-light p-2 cursor-pointer"
              @click="$i18n.locale = 'en'"
            >
              <svg
                viewBox="0 0 640 480"
                class="h-6 w-6 inline-block"
              >
                <path
                  fill="#012169"
                  d="M0 0h640v480H0z"
                />
                <path
                  fill="#FFF"
                  d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"
                />
                <path
                  fill="#C8102E"
                  d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"
                />
                <path
                  fill="#FFF"
                  d="M241 0v480h160V0H241zM0 160v160h640V160H0z"
                />
                <path
                  fill="#C8102E"
                  d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"
                />
              </svg>
            </div>
          </div>
          <RouterLink
            to="/profilo"
            class="block py-2 px-4 hover:bg-corepla-bg-light"
            @click="closeUserDropdown"
          >
            {{ $t('profile.profile') }}
          </RouterLink>
          <RouterLink
            to="/logout"
            class="block py-2 px-4 hover:bg-corepla-bg-light"
            @click="closeUserDropdown"
          >
            {{ $t('profile.logout') }}
          </RouterLink>
        </div>
      </div>
    </header>

    <div class="text-corepla-text flex-grow flex z-0">
      <RouterView />
    </div>
    
    <div
      v-if="errorsStore.errors.length > 0"
      class="fixed top-0 right-0 h-full w-full bg-gray-500 bg-opacity-70 z-40"
    >
      <div
        class="absolute border shadow bg-white w-[400px] h-[200px] left-1/2 top-1/2 -ml-[200px] -mt-[100px] flex flex-col pb-2"
      >
        <div class="bg-corepla-dark p-2 text-white">
          <ExclamationTriangleIcon class="h-5 w-5 inline mr-2" />
          {{ $t('errors.occurred') }}
        </div>
        <div class="flex-grow">
          <div
            v-for="error, i in errorsStore.errors"
            :key="'global-error-' + i"
            class="p-2 text-red-400 font-bold"
          >
            {{ error.message }}
          </div>
        </div>
        <div class="text-right m-2">
          <a
            href="#"
            class="btn btn-cancel"
            @click.prevent="closeErrorModal"
          >
            <span v-if="errorsStore.hasCriticalErrors">{{ $t('errors.logout') }}</span>
            <span v-else-if="errorsStore.hasFatalErrors">{{ $t('errors.forceRefresh') }}</span>
            <span v-else>{{ $t('errors.closeModal') }}</span>
          </a>
        </div>
      </div>
    </div>

    <div
      v-if="versionStore.newVersionAvailable"
      class="fixed top-0 right-0 h-full w-full bg-gray-500 bg-opacity-70 z-40"
    >
      <div
        class="absolute border shadow bg-white w-[400px] left-1/2 top-1/2 -ml-[200px] -mt-[100px] flex flex-col pb-2"
      >
        <div class="bg-corepla-dark p-2 text-white">
          <ArrowPathIcon class="h-5 w-5 inline mr-2" />
          {{ $t('version.new_available') }}
        </div>
        <div class="flex-grow p-4">
          {{ $t('version.message') }}
        </div>
        <div class="text-right m-2">
          <a
            href="#"
            class="btn btn-cancel"
            @click.prevent="versionStore.applyUpdate()"
          >
            {{ $t('version.update') }}
          </a>
        </div>
      </div>
    </div>

    <div
      v-if="notificationStore.notifications.length > 0"
      class="fixed bottom-10 right-10 z-50"
    >
      <div
        v-for="notification in notificationStore.notifications"
        :key="'notification-' + notification.id"
        :class="{ 'bg-green-600': notification.type == 'success', 'bg-red-600': notification.type == 'error', 'bg-yellow-400': notification.type == 'info' }"
        class="rounded bg-green-600 text-white px-2 py-1 mb-2 shadow font-bold"
      >
        {{ notification.message }}
        <XMarkIcon
          class="h-4 w-4 inline-block cursor-pointer"
          @click="notificationStore.removeNotification(notification.id)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowPathIcon,Bars3Icon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { vOnClickOutside } from '@vueuse/components'
import { ref } from 'vue';
import { RouterLink, RouterView, useRouter } from 'vue-router'

import dateUtils from '@/services/date-utils';

import { useAuthStore } from './stores/auth';
import { useClockStore } from './stores/clock';
import { useErrorsStore } from './stores/errors';
import { useNotificationsStore } from './stores/notifications';
import { useUiStore } from './stores/ui';
import { useVersionStore } from './stores/version';

const authStore = useAuthStore()
const errorsStore = useErrorsStore();
const notificationStore = useNotificationsStore()
const uiStore = useUiStore();
const clockStore = useClockStore()
const versionStore = useVersionStore()
const router = useRouter();

const closeUserDropdown = function () {
  userDropdown.value = false
}

const userDropdown = ref(false)

const closeErrorModal = function () {
  if(errorsStore.hasCriticalErrors) {
    router.push('/logout');
    return;
  }

  if(errorsStore.hasFatalErrors) {
    window.location.reload();
    return;
  }

  errorsStore.resetStore()
}

const toggleMenu = function () {
  uiStore.menu = !uiStore.menu;
}

const version = __APP_VERSION__
</script>